import Component from "./SelectionCell";
import Content from "./components/Content/SelectionCellContent";
import Control from "./components/Control/SelectionCellControl";

interface ISelectionCellExtensions {
    Content: typeof Content;
    Control: typeof Control;
}

export const SelectionCell: typeof Component & ISelectionCellExtensions =
    Object.assign(Component, {
        Content,
        Control,
    });

export type { SelectionCellProps } from "./types";
